export interface ITermsData {
  fiscalSetupId: number;
}
